import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "cell-card"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "header-cont"
};
const _hoisted_5 = {
  class: "body"
};
export default {
  __name: 'CellCard',
  props: {
    title: String
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "header")])]), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "default")])]);
    };
  }
};